export const landingRecruitData = (course: string) => [
  {
    title: `지원서 접수 * 9/15(토) 마감`,
    desc: "온라인 지원서를 제출합니다.",
  },
  {
    title: "화상 인터뷰",
    desc: "서류 합격자에 한해 선착순으로\n" + "화상 인터뷰를 진행합니다.",
  },
  {
    title: "합격 & 사전준비",
    desc: "합격 후, 0주차 사전학습을 통해\n" + "SW캠프를 준비합니다.",
  },
  {
    title: "SW캠프 시작",
    desc: `${
      course === "pm"
        ? "탁월한 PM으로의 여정을 시작합니다."
        : "시장을 주도하는 마케터가 됩니다."
    }`,
  },
];
